export default "__VITE_ASSET__8b42f240__"